export function getTodaysDate() {
    return new Date().toJSON().split("T")[0]
}

export function getPastDateByMonth(pastMonth) {
    const start = new Date()
    start.setMonth(start.getMonth() - pastMonth)
    return start.toJSON().split("T")[0]
}
export function dateDifference(date1, date2) {
  return (Date.parse(date2) - Date.parse(date1)) / (1000  * 60 * 60 * 24)
}

export const normalizeNumInRange = (value, [ valueMin, valueMax ], [ rangeMin, rangeMax ]) => {
  return (rangeMax - rangeMin) * (value - valueMin) / (valueMax - valueMin) + rangeMin
}

export const deNormalizeNumInRange = (value, [ valueMin, valueMax ], [ rangeMin, rangeMax ]) => {
  return (valueMin* (1 - value) + value*valueMax-rangeMin) / (rangeMax - rangeMin)
}

export const dateFormat = (timeStamp) => {
  //2023-09-05 09:30:25+0000
  let [date, time] = timeStamp.split(" ")
  time = time.split(":")[0] +":" + time.split(":")[1]
  return date + " " + time
}


export const mapProjectScanToVulnsFixed = (remediations, scan) => {
  let mapped = {...scan, vulnsFixed: []}
  remediations.vulnerabilities.forEach((vuln) => {
    if(vuln.fixedWhen === scan.timestamp) mapped.vulnsFixed.push(vuln)
  })
  return mapped
}

export const openLink = (link) => {
  window.open(link, "_blank")
}

export const mapSeverityToClassName = (severity, className) => {
  return severity.toLowerCase() + "-" + className;
}

export const vulnIdFormat = (id) => {
  return id.startsWith("CVE") || id.startsWith("CWE") ? id: "MET-" + id.split("-")[0]
}